import React, { ReactNode } from "react";
import { TFunction } from "i18next";
import reactStringReplace from "react-string-replace";
import { IUnderlyingsInTextData } from "src/api/server/news.types";
import { INumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { MentionReplacement } from "./mention-replacement";

interface IParagraphProcessorProps {
    paragraph: string;
    underlyingsInTextData: IUnderlyingsInTextData[];
    formatPerformance: INumberFormatter["formatPerformance"];
    t: TFunction;
    buildWikifolioLink: (symbol: string) => string;
}

export const ParagraphProcessor = ({ paragraph, underlyingsInTextData, formatPerformance, t, buildWikifolioLink }: IParagraphProcessorProps) => {
    let processedText: ReactNode[] | string = paragraph;

    underlyingsInTextData.forEach(underlying => {
        const { performanceSinceCreation, symbol } = underlying.wikifolio;
        const performance = formatPerformance(performanceSinceCreation, 1);
        const portfolioText = t("in-text-mention.in-the-portfolio-of");
        const link = buildWikifolioLink(symbol);
        const traderName = `${underlying.trader.firstName} ${underlying.trader.lastName}`;
        const isinTag = `<${underlying.underlyingIsin}>`;

        processedText = reactStringReplace(processedText, isinTag, () => (
            <MentionReplacement
                key={underlying.underlyingIsin}
                portfolioText={portfolioText}
                link={link}
                traderName={traderName}
                performance={performance}
            />
        ));
    });

    return processedText;
};
